/** @module wgfractals/util/pixels */

/**
 * Copies a Uint32Array of packed 0xAABBGGRR pixels straight into a canvas.
 * WGSL's little-endian u32 and `Uint8ClampedArray`/`ImageData` both lay out
 * 0xAABBGGRR as bytes `[R, G, B, A]` in memory, so the GPU readback buffer
 * can be viewed as bytes and handed to `putImageData` with no repacking —
 * see `colorize()`/`colorizeRoot()` in `src/shaders/helpers/palette.wgsl`,
 * which pack pixels in that exact byte order.
 * @param {CanvasRenderingContext2D} ctx
 * @param {Uint32Array} pixels - length must equal `width * height`
 * @param {number} width
 * @param {number} height
 */
export function blitToCanvas(ctx, pixels, width, height) {
  const bytes = new Uint8ClampedArray(pixels.buffer, pixels.byteOffset, pixels.byteLength);
  ctx.putImageData(new ImageData(bytes, width, height), 0, 0);
}
